import { render, staticRenderFns } from "./NovelInfoCard.vue?vue&type=template&id=27f69649&scoped=true&"
import script from "./NovelInfoCard.vue?vue&type=script&lang=js&"
export * from "./NovelInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./NovelInfoCard.vue?vue&type=style&index=0&id=27f69649&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f69649",
  null
  
)

export default component.exports